export const tablefields = [
	{
		'name': 'date',
		'value': 'created_at',
		'type': 'date',
		'width': 80,
		'sticky': true,
		'sticky_value': 0,
		'visible': true,
	},
	{
		'name': 'user',
		'value': 'user_name',
		'class': 'AlignLeft',
		'visible': true,
	},
	{
		'name': 'Status',
		'value': 'se_st_name',
		'type': 'back_translate',
		'class': 'AlignLeft',
		'visible': true,
	},
]